<ic-popup-frame
	[title]="'medication.add_medication.add_unknown' | translate"
	(cancelPopup)="onCancel()"
	(confirm)="onConfirm()"
>
	<form [formGroup]="form">
		<fieldset>
			@if (form.get("description"); as control) {
				<div class="input-group" [class.error]="control.touched && control.errors">
					<label for="description">{{
						"medication.found_medication_incidents.steps.details.description" | translate
					}}</label>
					<input data-test="description-input" formControlName="description" id="description" type="text" />
					<medication-input-error [errors]="control.errors" [touched]="control.touched" />
				</div>
			}

			@if (form.get("quantity"); as control) {
				<div class="input-group" [class.error]="control.touched && control.errors">
					<label for="quantity">{{ "medication.found_medication_incidents.steps.details.quantity" | translate }}</label>
					<input data-test="quantity-input" formControlName="quantity" id="quantity" type="number" />
					<medication-input-error [errors]="control.errors" [touched]="control.touched" />
				</div>
			}
		</fieldset>
	</form>
</ic-popup-frame>
